import { requestRmaButtonsStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaButtons";
import { headerStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaHeader";
import { requestRmaInformationStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaInformation";
import { requestRmaProductListStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

requestRmaButtonsStyles.sendButton = {
    variant: "primary",
    css: css`
        margin-left: 10px;
        span {
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 2px;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            text-transform: uppercase;
        }
    `,
}

requestRmaButtonsStyles.narrowOverflowMenu = {
    cssOverrides:{
        wrapper:css`
            span {
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF !important;
            }
        `,
    }
}

headerStyles.buttonsGridItem = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 1, 6, 6],
}

headerStyles.titleGridItem = {
    width: [10, 10, 11, 6, 6],
}

requestRmaProductListStyles.productPartNumbers = {
    erpNumberLabelText: {
        css: css`
            margin-right: 8px;
        `,
    },
    customerNameLabelText: {
        css: css`
            margin-right: 8px;
        `,
    },
    manufacturerItemLabelText: {
        css: css`
            margin-right: 8px;
        `,
    },
    erpNumberValueText: {
        css: css`
            font-size: 14px;
            font-weight: 500;
            color: #006bc0;
        `,
    },
}

requestRmaProductListStyles.productDescriptionStyles = {
    productDetailLink:{
        css: css`
            span {
                color: #33333a !important;
                font-size: 16px;
                font-weight: 600;
                &:hover {
                    color: #006bc0 !important;
                }
            }
        `,
    }
}

requestRmaInformationStyles.wrapper = {
    css: css`
        display: flex;
        padding-bottom: 20px;
        div {
        &:last-child {
            flex-basis:50%;
            max-width:50%;
        }
    }
    `,
}

requestRmaInformationStyles.fieldWrapper = {
    css: css`
        margin-right: 25px;
        flex-basis:20%;
        max-width:20%;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                css`
                    flex-basis:45%;
                    max-width:45%;
                `,
                css`
                    flex-basis:40%;
                    max-width:40%;
                `,
                css`
                    flex-basis:35%;
                    max-width:35%;
                `,
                null,
                null
            ]
        )}
    `,
}